import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api, ApiError } from '../api-client.js';
import { AuthCard, AuthField, AuthSubmit } from './AuthFormShell.js';
import { useAuthStore } from './auth-store.js';

export default function LoginPage() {
  const navigate = useNavigate();
  const setSession = useAuthStore((s) => s.setSession);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const result = await api.login({ email, password });
      setSession(result.user, result.tokens);
      navigate('/');
    } catch (error) {
      const message = error instanceof ApiError ? error.message : 'Login failed';
      setError(message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthCard
      title="Log in"
      subtitle="Welcome back."
      onSubmit={onSubmit}
      footer={
        <>
          No account?{' '}
          <Link to="/register" className="text-ec-brass hover:underline">
            Register
          </Link>
        </>
      }
    >
      <AuthField
        label="Email"
        type="email"
        value={email}
        onChange={setEmail}
        autoComplete="email"
        inputMode="email"
        placeholder="you@example.com"
        required
      />
      <AuthField
        label="Password"
        type={showPassword ? 'text' : 'password'}
        value={password}
        onChange={setPassword}
        autoComplete="current-password"
        required
        trailing={
          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            className="px-2 text-xs font-medium text-ec-bone hover:text-ec-face"
            tabIndex={-1}
          >
            {showPassword ? 'Hide' : 'Show'}
          </button>
        }
      />
      {error && (
        <p
          role="alert"
          className="rounded-md border border-ec-oxblood bg-[rgba(39,147,211,0.22)] px-3 py-2 text-sm text-ec-face"
        >
          {error}
        </p>
      )}
      <AuthSubmit busy={submitting} busyLabel="Signing in…" label="Sign in" />
    </AuthCard>
  );
}
